const doc = [({"en":({"js":({"teams":({"selector":({"choose_team":({"individual":"Individual", "join_team":"Join a team"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;